export default `---
slug: hungary
country: Hungary
countryCode: HUN
continent: Europe
year: 2017
title: "Hungary"
description: "Budapest — thermal baths, ruin bars, and the Danube at golden hour."
thumbnail: /images/travels/HUN/hungary_thumb.jpg
relatedLinks: []
---
![hungary](/images/travels/HUN/hungary_thumb.jpg)

*Story coming soon — stay tuned!*

I visited Hungary and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
